// ResourceItem.js
import React from 'react';
import { useDrag } from 'react-dnd';

const ResourceItem = ({ resource, isDisabled }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: resource.type,
      item: { id: resource.id, type: resource.type, label: resource.label },
      canDrag: !isDisabled,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [isDisabled]
  );

  const [isHovered, setIsHovered] = React.useState(false);

  const style = {
    height: '44px',
    borderRadius: '10px',
    padding: '0 16px',
    width: '100%',
    fontSize: '13px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
    userSelect: 'none',
    boxSizing: 'border-box',
    marginBottom: '10px',
    ...(isDisabled
      ? {
          background: '#f1f5f9',
          color: '#94a3b8',
          cursor: 'not-allowed',
          border: '1px solid #e2e8f0',
          boxShadow: 'none',
        }
      : {
          background: isHovered ? '#1e40af' : '#1a56db',
          color: '#ffffff',
          cursor: isDragging ? 'grabbing' : 'grab',
          border: 'none',
          boxShadow: isHovered 
            ? '0 4px 8px rgba(15,45,94,0.18)' 
            : '0 1px 3px rgba(15,45,94,0.1)',
          transform: isHovered ? 'translateY(-1px)' : 'none',
          opacity: isDragging ? 0.7 : 1,
        }),
  };

  return (
    <div
      ref={isDisabled ? null : drag}
      style={style}
      onMouseEnter={() => !isDisabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {resource.label}
    </div>
  );
};

export default ResourceItem;
